/** F21 — normalized grid (multiples of 0.04) for slide layout rhythm. */
export const SURF_GRID_UNIT = 0.04;
export const SURF_GRID_MARGIN = { x: 0.08, y: 0.12 };
export const SURF_GRID_GUTTER = SURF_GRID_UNIT;
export const SURF_GRID_COLS = 21;
export const SURF_GRID_ROWS = 19;
export const SURF_GRID_CONTENT = {
    x: SURF_GRID_MARGIN.x,
    y: SURF_GRID_MARGIN.y,
    w: SURF_GRID_COLS * SURF_GRID_UNIT,
    h: SURF_GRID_ROWS * SURF_GRID_UNIT,
};
export const SURF_GRID_HALF_COL_W = (SURF_GRID_CONTENT.w - SURF_GRID_GUTTER) / 2;
export const SURF_GRID_LEFT_COL = {
    x: SURF_GRID_CONTENT.x,
    w: SURF_GRID_HALF_COL_W,
};
export const SURF_GRID_RIGHT_COL = {
    x: SURF_GRID_CONTENT.x + SURF_GRID_HALF_COL_W + SURF_GRID_GUTTER,
    w: SURF_GRID_HALF_COL_W,
};
/** Place a rectangle on the column/row grid (0-based within content area). */
export function gridRect(col, row, colSpan, rowSpan) {
    return {
        x: SURF_GRID_MARGIN.x + col * SURF_GRID_UNIT,
        y: SURF_GRID_MARGIN.y + row * SURF_GRID_UNIT,
        w: colSpan * SURF_GRID_UNIT,
        h: rowSpan * SURF_GRID_UNIT,
    };
}
/** Snap a normalized rect to the nearest grid lines (for custom layouts). */
export function snapRectToGrid(rect) {
    const snap = (v) => Math.round(v / SURF_GRID_UNIT) * SURF_GRID_UNIT;
    return {
        x: snap(rect.x),
        y: snap(rect.y),
        w: Math.max(SURF_GRID_UNIT, snap(rect.w)),
        h: Math.max(SURF_GRID_UNIT, snap(rect.h)),
    };
}
